import { atom } from 'recoil';

import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'giftCart',
  storage: typeof window !== 'undefined' ? localStorage : undefined,
});

export interface GiftCartItem {
  itemId: string;
  itemName: string;
  itemImage?: string;
  priceRetail: number;
  quantity: number;
  minOrderQuantity: number;
  orderUnit: number;
  bugoId: string;
}

export const giftCartAtom = atom<GiftCartItem[]>({
  key: 'giftCartAtom',
  default: [],
  effects_UNSTABLE: [persistAtom],
});
